import dayjs from 'dayjs';
import { IComponent } from 'src/interfaces';

import { IScheduledSectionComponent } from '../../../ScheduleComponentPage.interface';

export const getOverrideDateLimits = (
  mainComponent: IScheduledSectionComponent,
  selectedComponent?: IComponent,
  overrideStartDate?: string,
) => {
  if (!selectedComponent) return {};

  const mainStart = mainComponent.scheduleStartDate
    ? dayjs(mainComponent.scheduleStartDate)
    : undefined;
  const mainEnd = mainComponent.scheduleEndDate
    ? dayjs(mainComponent.scheduleEndDate)
    : undefined;
  const softSellStart = selectedComponent?.start_date
    ? dayjs(selectedComponent.start_date)
    : undefined;
  const softSellEnd = selectedComponent?.end_date
    ? dayjs(selectedComponent.end_date)
    : undefined;

  // startDateMin: latest of mainStart and softSellStart
  let startDateMin = undefined;
  if (mainStart && softSellStart) {
    startDateMin = mainStart.isBefore(softSellStart)
      ? softSellStart
      : mainStart;
  } else {
    startDateMin = mainStart ?? softSellStart;
  }

  // endDateMax: earliest of mainEnd and softSellEnd
  let endDateMax = undefined;
  if (mainEnd && softSellEnd) {
    endDateMax = mainEnd.isBefore(softSellEnd) ? mainEnd : softSellEnd;
  } else {
    endDateMax = mainEnd || softSellEnd;
  }

  // endDateMin: latest of (mainStart, softSellStart, overrideStartDate)
  let endDateMin = undefined;
  const allStartDates = [mainStart, softSellStart];
  if (overrideStartDate) {
    allStartDates.push(dayjs(overrideStartDate));
  }

  const latestStartDate = allStartDates
    .filter(Boolean)
    .reduce((latest, current) => {
      return latest && latest.isAfter(current) ? latest : current;
    }, undefined);

  if (latestStartDate) {
    if (endDateMax && latestStartDate.isAfter(endDateMax)) {
      endDateMin = undefined;
    } else {
      endDateMin = latestStartDate;
    }
  }
  // startDateMax: endDateMax
  let startDateMax = endDateMax ? endDateMax : undefined;

  return {
    startDateMin,
    startDateMax,
    endDateMin,
    endDateMax,
    isStartDateDisabled: () => false,
    isEndDateDisabled: () => false,
  };
};

export const isScheduledComponentExpired = (scheduleEndDate?: string | null) =>
  scheduleEndDate ? dayjs().isAfter(dayjs(scheduleEndDate), 'day') : false;
